/*
@Description: 众配云官网路由
@Version: 1.0.0(2021-12-06)
@author: 陈培武
==NOTES:=============================================
2021-12-06:
初始生成。
2022-04-18：
修改并合并CA01~CA07路由
@author：杨粤
*/
const isMobile = () => {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

var router = [
  // 首页
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/index.vue'),
    beforeEnter (to, from, next) {
      if (isMobile()) {
        window.location.href = `${window.location.origin}/A01_B09_CA01/home`
      }
      next()
    }
  },
  // 配件目录
  {
    path: '/epc-search',
    name: 'epc-search',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/EpcSearch.vue')
  },
  // 智慧仓库
  {
    path: '/sku-share',
    name: 'sku-share',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/SkuShare.vue')
  },
  // 品牌目录
  {
    path: '/pc-brand',
    name: 'pc-brand',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/PcBrand.vue')
  },
  // 维修资料
  {
    path: '/technical-data',
    name: 'technical-data',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/TechnicalData.vue')
  },
  // 业务撮合
  {
    path: '/data-service',
    name: 'data-service',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/DataService.vue')
  },
  // 关于我们
  {
    path: '/aboutus',
    name: 'aboutus',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/AboutUs.vue')
  },
  {
    path: '/dynamic',
    name: 'dynamic',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/url'),
    beforeEnter(to, from, next) {
      if (isMobile()) {
        document.head.appendChild(document.createElement('meta'))
        document.head.firstElementChild.setAttribute('name', 'viewport')
        document.head.firstElementChild.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0')
        to.meta.module = 'A01_B09_CA01'
      } else {
        to.meta.module = 'A02_B11_CA01'
      }
      next()
    }
  },
  {
    path: '/enquiry',
    name: 'enquiry',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/url'),
    beforeEnter(to, from, next) {
      if (isMobile()) {
        document.head.appendChild(document.createElement('meta'))
        document.head.firstElementChild.setAttribute('name', 'viewport')
        document.head.firstElementChild.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0')
        to.meta.module = 'A01_B09_CA01'
      } else {
        to.meta.module = 'A08_B01_CA01'
      }
      next()
    }
  },
  {
    path: '/quote',
    name: 'quote',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/url'),
    beforeEnter(to, from, next) {
      if (isMobile()) {
        document.head.appendChild(document.createElement('meta'))
        document.head.firstElementChild.setAttribute('name', 'viewport')
        document.head.firstElementChild.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0')
        to.meta.module = 'A01_B09_CA01'
      } else {
        to.meta.module = 'A08_B01_CA01'
      }
      next()
    }
  },
  {
    path: '/purchase',
    name: 'purchase',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/url'),
    beforeEnter(to, from, next) {
      if (isMobile()) {
        document.head.appendChild(document.createElement('meta'))
        document.head.firstElementChild.setAttribute('name', 'viewport')
        document.head.firstElementChild.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0')
        to.meta.module = 'A01_B09_CA01'
      } else {
        to.meta.module = 'A08_B01_CA01'
      }
      next()
    }
  },
  {
    path: '/inteldecode',
    name: 'inteldecode',
    component: () => import('@/views/A01/A01_B00/A01_B00_CA01/url'),
    beforeEnter(to, from, next) {
      if (isMobile()) {
        document.head.appendChild(document.createElement('meta'))
        document.head.firstElementChild.setAttribute('name', 'viewport')
        document.head.firstElementChild.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0')
        to.meta.module = 'A01_B09_CA01'
      } else {
        to.meta.module = 'A08_B01_CA01'
      }
      next()
    }
  },
]
export default router



// WEBPACK FOOTER //
// ./src/router/A01/A01_B00/A01_B00_CA01/index.js